










































































































import Vue from 'vue'
// @ts-ignore
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProductStorage from '@/components/master-data/product/ProductStorage.vue'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import ProductPrice from '@/components/master-data/product/ProductPrice.vue'
import {
  DELETE_PRODUCT_PRICE,
  DELETE_PRODUCT_STORAGE_DATA,
  FETCH_PRODUCT_STORAGE_DATA,
  FETCH_PRODUCT_STORAGE_METADATA, UPSERT_PRODUCT_PRICE, UPSERT_PRODUCT_STORAGE_DATA
} from '@/store/action-types'
import { ProductSearchRecord } from '@/model/products/ProductSearchRecord'
import { DeleteProductStoragePayload, UpsertProductPricePayload } from '@/types/payload'


interface ComponentData {
  loading: boolean
  storageLoading: boolean
  priceLoading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  activeTab: number
  isCreate: boolean
  isUpdate: boolean




  gridData: any[]
  selectedLagerungenId: number
  storageData: any | null
  storageMetaData: any | null

  selectedPriceId: number | null
}

export default Vue.extend({
  name: 'ProductStorageAndPricing',

  components: {
    ProductStorage,
    ProductPrice,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    productId: Number,
    selectedProduct: Object as () => ProductSearchRecord
  },

  data (): ComponentData {
    return {
      loading: false,
      storageLoading: false,
      priceLoading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      activeTab: 0,
      isCreate: false,
      isUpdate: false,



      gridData: [],
      selectedLagerungenId: 0,
      storageData: null,
      storageMetaData: null,

      selectedPriceId: null
    }
  },

  watch: {
    productId (newVal: number): void {
      if(newVal && newVal !== 0) {

      }
    },

    activeTab (newVal: number): void {
      this.isCreate = false
      this.isUpdate = false

      this.selectedPriceId = null
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onRowClick (data: any): void {
      this.selectedLagerungenId = data.data.ID
      this.fetchStorageData(false)
    },

    onCreateClick (): void {
      this.isCreate = true
      this.isUpdate = false
      if(this.activeTab === 0) {
        this.storageData = null
        this.selectedLagerungenId = 0
        //@ts-ignore
        this.$refs.dataGrid.instance.selectRows([])
      }
    },

    onUpdateClick (): void {
      if(this.activeTab === 0) {
        if (this.selectedLagerungenId) {
          this.isUpdate = true
        }
      } else if(this.activeTab === 2) {
        if (this.selectedPriceId) {
          this.isUpdate = true
        }
      }
      this.isCreate = false
    },

    onDeleteClick (): void {
      this.isCreate = false
      this.isUpdate = false

      if(this.activeTab === 0) {
        this.deleteProductStorage()
      } else if(this.activeTab === 2) {
        if(this.selectedPriceId) {
          this.deleteProductPrice()
        }
      }
    },

    onCancelClick (): void {
      if(this.activeTab === 0) {
        if(this.isCreate && this.gridData) {
          const foundLagerung: any | undefined = this.gridData.find((item: any) => item.Bevorzugt)
          if(foundLagerung) {
            this.selectedLagerungenId = foundLagerung.ID
            //@ts-ignore
            setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedLagerungenId])}, 100)
            this.fetchStorageData(false)
          } else if(this.isCreate && this.gridData && this.gridData[0]) {
            this.selectedLagerungenId = this.gridData[0].ID
            //@ts-ignore
            setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedLagerungenId])}, 100)
            this.fetchStorageData(false)
          } else {
            this.selectedLagerungenId = 0
            //@ts-ignore
            this.$refs.dataGrid.instance.selectRows([])
          }
        }
      }
      this.isCreate = false
      this.isUpdate = false
    },

    async upsertProductStorage (payload: any): Promise<void> {
      try {
        this.storageLoading = true
        const response: any = await this.$store.dispatch(UPSERT_PRODUCT_STORAGE_DATA, payload)
        if (!response.IsError && response.Lagerung !== -1) {
          this.selectedLagerungenId = response.Lagerung ? response.Lagerung : 0
          this.isCreate = false
          this.isUpdate = false
          this.fetchStorageData(false)
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.storageLoading = false
      }
    },

    async deleteProductStorage (): Promise<void> {
      const payload: DeleteProductStoragePayload = {
        produktId: this.selectedProduct.id,
        lagerungenId: this.selectedLagerungenId
      }

      try {
        this.loading = true
        const response: any = await this.$store.dispatch(DELETE_PRODUCT_STORAGE_DATA, payload)
        if(!response.IsError) {
          this.selectedLagerungenId = 0
          this.fetchStorageData(false)
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.loading = false
      }
    },

    async upsertProductPrice (payload: UpsertProductPricePayload): Promise<void> {
      try {
        this.priceLoading = true
        const response: any = await this.$store.dispatch(UPSERT_PRODUCT_PRICE, payload)
        if (!response.IsError || response.Lagerung !== -1) {
          this.isCreate = false
          this.isUpdate = false
          this.fetchStorageData(false)
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.priceLoading = false
      }
    },

    setPriceId (id: number): void {
      this.selectedPriceId = id
    },

    async deleteProductPrice (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(DELETE_PRODUCT_PRICE, this.selectedPriceId)
        if(!response.IsError) {
          this.fetchStorageData(false)
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.loading = false
      }
    },

    async fetchStorageData (isFirstTime: boolean): Promise<void> {
      const payload: any = {
        produktId: this.selectedProduct.id,
        lagerungId: this.selectedLagerungenId
      }

      try {
        const response: any = await this.$store.dispatch(FETCH_PRODUCT_STORAGE_DATA, payload)
        if(!response.IsError && response.Data) {
          this.storageData = response.Data
          this.gridData = response.Data.DispLagerungen
          if(isFirstTime) {
            const foundLagerung: any | undefined = this.gridData.find((item: any) => item.Bevorzugt)
            if(foundLagerung) {
              this.selectedLagerungenId = foundLagerung.ID
              //@ts-ignore
              setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedLagerungenId])}, 100)
            } else if(this.gridData[0]) {
              this.selectedLagerungenId = this.gridData[0].ID
              this.fetchStorageData(false)
            }
          } else if(this.selectedLagerungenId) {
            //@ts-ignore
            setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedLagerungenId])}, 100)
          }
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchStorageMetadata (): Promise<void> {
      try {
        const response: any = await this.$store.dispatch(FETCH_PRODUCT_STORAGE_METADATA, this.selectedProduct.einheit)
        if(!response.IsError && response.Data) {
          this.storageMetaData = response.Data
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted () {
    this.fetchStorageData(true)
    this.fetchStorageMetadata()
  }

})
